import React from 'react';
import ListItem from './Item';
import * as styles from './itemList.module.css';

type Props = {
  posts: {
    slug: string;
    title: string;
    date: string;
    tags?: {
      name: string;
      slug: string;
    }[];
    icon?: string;
    year: string;
  }[];
  postsByYear: any;
  className?: string;
  showTags?: boolean;
};

const ItemList = ({
  posts,
  postsByYear,
  className,
  showTags = true,
}: Props) => {
  const years = postsByYear && Object.keys(postsByYear).sort().reverse();
  return (
    <div className={styles.listing}>
      {postsByYear
        ? years.map((year, i) => (
            <React.Fragment key={i}>
              <ListItem
                key={year}
                year={year}
                count={postsByYear[year].length}
              />{' '}
              {postsByYear[year].map((post) => (
                <ListItem key={post.slug} post={post} showTags={showTags} />
              ))}
            </React.Fragment>
          ))
        : posts.map((post) => (
            <ListItem key={post.slug} post={post} showTags={showTags} />
          ))}
    </div>
  );
};

export default ItemList;
